export default {
    namespaced: true,
    state: () => ({
        loadingCount: 0
    }),
    mutations: {
        INCREMENT_LOADING(state) {
        state.loadingCount++;
        },
        DECREMENT_LOADING(state) {
        if (state.loadingCount > 0) state.loadingCount--;
        }
    },
    getters: {
        isLoading: state => state.loadingCount > 0
    }
};
